(function componentForm($, Adzuki)
{
	"use strict";

	var form   = {
		name: 'ReservationCommentManage',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $comment_model    = $("#reservationcommentmanage-model"),
		    $show_on_invoice  = $("#reservationcommentmanage-show_on_invoice"),
		    $invoice_location = $("#reservationcommentmanage-location");

		if ($comment_model.val() === 'ReservationComment') {
			$invoice_location.prop('disabled', false);

			// toggle invoice location based on showing or not
			$show_on_invoice.on('click', function click(e)
			{
				if ($show_on_invoice.prop( "checked" ) === true) {
					$('#invoice_location').removeClass('hidden');
				} else {
					$('#invoice_location').addClass('hidden');
				}
			});
		} else {
			// toggle agent dummy text
			$show_on_invoice.on('click', function click(e)
			{
				if ($show_on_invoice.prop( "checked" ) === true) {
					$('#show_on_invoice_alert').removeClass('hidden');
				} else {
					$('#show_on_invoice_alert').addClass('hidden');
				}
			});
		}
	};
}(jQuery, window.Adzuki || {}));
